module.exports = __webpack_public_path__ + "assets/img/00032.5e5b812a.png";